import { instance as CompanyInstance } from '../../../factory/company';
import UserInfoFactory from '../../../factory/user-info';
import { logError } from 'src/utils/logger';

module.exports = _.extend({
  initialize: async function () {
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;
    /* INKIVE.EditorFacade.on('editor.loaded', () => {
      const load = () => {
        this.load().then(() => {
          INKIVE.EditorFacade.handle('download', 'load');
        });
      };

      INKIVE.C.TRANSLATION_DATA ? INKIVE.EditorFacade.on('translation.loaded', load) : load();
    }); */
  },

  display: async function (data = {}) {
    const [projectData, companyData] = await Promise.all([
      CompanyInstance.fetchProjectData(),
      CompanyInstance.getCompanyData()
    ]);

    const userInfoData = await UserInfoFactory.get();

    CONFIG.viewer_url = INKIVE.C.VIEWER;
    CONFIG.company_id = companyData.id;
    CONFIG.company_name = companyData.name;

    if (!this._shareApp) {
      INKIVE.Modal.togglePageLoader(true);
      const shareButton = document.querySelector('button[data-action="share"]');
      let didLoadFail = true;
      shareButton.classList.add('disabled');
      shareButton.classList.remove('active');

      /**
       * It checks if download/share component were properly loaded. Otherwise, It logs an error
       */
      setTimeout(() => {
        didLoadFail && logError('share.display', 'Loading timed out');
      }, 5000);

      INKIVE.Helpers.systemDeferred && await INKIVE.Helpers.systemDeferred;
      await (this._loadingPromise = this._loadingPromise || this.load());

      didLoadFail = false;

      shareButton.classList.remove('disabled');
      INKIVE.Modal.togglePageLoader(false);
    }

    this._shareApp && this._shareApp.invoke('toggle', {
      design: projectData,
      plan: userInfoData.roles.includes('ROLE_PREMIUM') ? 'pro' : 'free',
      previewUrl: projectData.pages[INKIVE.EditorFacade.get('page').current - 1]?.thumbnail,

      closeCallback: () => document.querySelector('[data-action=share]').classList.remove('active')
    });
  },

  openUpgradeModal: function (paymentOptions) {
    const callbackFunction = () => {
      document.querySelector('.payment-modal > div').classList.add('aurelia-hide');
      document.querySelector('[data-id=upgrade]')?.remove();
      UserInfoFactory.get().then(u => {
        UserInfoFactory.isProUser() || u.roles.push('ROLE_PRO');
        u.is_on_trial = false;
      });
    };
    INKIVE.Helpers.displaySubscriptionModal('', 'pro', true, null, paymentOptions, callbackFunction);
  },

  load: async function () {
    const appNode = document.createElement('div');
    appNode.id = 'share-modal';
    appNode.setAttribute('aurelia-app', 'share-modal/main');

    document.querySelector('#content').appendChild(appNode);

    await INKIVE.Helpers.getAureliaLibraries($(appNode));
    const { adapter } = await System.import('@desygner/adapter/adapter');
    this._shareApp = adapter.getAdapterByDomElement(appNode);

    await new Promise(resolve => INKIVE.Helpers.afterRendering(resolve));
    window.addEventListener('resize', this._calculateModalPosition);
  },

  _calculateModalPosition () {
    const modal = document.querySelector('[ref="modalRootRef"].compact');

    if (modal) {
      window.requestAnimationFrame(() => {
        const button = document.querySelector('button[data-action="share"]').getBoundingClientRect();

        modal.style.marginLeft = '';
        modal.style.cssText = `${modal.style.cssText} margin-left: ${button.left + button.width - modal.getBoundingClientRect().width}px`;
      });
    }
  }
}, Backbone.Events);
